// extracted by mini-css-extract-plugin
export default {"sectionTitle":"phaNDz","domainTitle":"HeO_HQ","domainTitlePerception":"zhGUpy","pricing":"avgx5M"};